<template>
  <div class="table-wrapper">
    <table>
      <caption class="visually-hidden">
        {{
          $t('WHATSAPP_CONSUMPTIONS_REPORT.HEADER')
        }}
      </caption>
      <thead>
        <tr>
          <th>{{ $t('WHATSAPP_CONSUMPTIONS_REPORT.TABLE.INBOX') }}</th>
          <th v-for="(label, categoryKey) in categoryLabels" :key="`tr_${categoryKey}`">
            {{ categoryLabel(categoryKey) }}
          </th>
          <th>{{ $t('WHATSAPP_CONSUMPTIONS_REPORT.TOTAL') }}</th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="(item, index) in paginatedData"
          :key="index"
          :class="{ 'striped-row': index % 2 !== 0 }"
        >
          <td>{{ item.name || '-' }}</td>
          <td v-for="(label, categoryKey) in categoryLabels" :key="`td_${categoryKey}`">
            {{ item[categoryKey] ? item[categoryKey] : 0 }}
          </td>
          <td>{{ getTotal(item) }}</td>
        </tr>
        <tr v-if="loading">
          <td colspan="6">
            <spinner :colorScheme="'dark'" />
          </td>
        </tr>
      </tbody>
    </table>

    <div class="pagination" v-if="!loading">
      <button @click="goToPage(currentPage - 1)" :disabled="currentPage === 1">
        {{ $t('WHATSAPP_CONSUMPTIONS_REPORT.PAGINATION.PREVIOUS') }}
      </button>
      <span>
        {{ $t('WHATSAPP_CONSUMPTIONS_REPORT.PAGINATION.PAGE') }} {{ currentPage }}
        {{ $t('WHATSAPP_CONSUMPTIONS_REPORT.COMMON.OF') }} {{ totalPages }}
      </span>
      <button
        @click="goToPage(currentPage + 1)"
        :disabled="currentPage === totalPages"
      >
        {{ $t('WHATSAPP_CONSUMPTIONS_REPORT.PAGINATION.NEXT') }}
      </button>
    </div>
  </div>
</template>

<script>

import Spinner from 'shared/components/Spinner.vue';

export default {
  name: 'WhatsappEventsReasonsTable',
  components: {    
    Spinner
  },
  props: {
    data: {
      type: Array,
      required: true,
    },
    loading: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      currentPage: 1,
      perPage: 100,
    };
  },
  computed: {   
    paginatedData() {
      const start = (this.currentPage - 1) * this.perPage;
      return this.rows.slice(start, start + this.perPage);
    },
    totalPages() {
      return Math.ceil(this.data.length / this.perPage);
    },
    rows(){
      if(this.data.length == 0 || this.loading){
        return [];
      }
      const results = JSON.parse(JSON.stringify(this.data));;
      const grouped = {};
      results.forEach(result => {
        if (!grouped[result.phone_number]) {
          grouped[result.phone_number] = result;
        }else{          
          Object.keys(this.categoryLabels).forEach(category => {            
            if(!grouped[result.phone_number][category]){
              grouped[result.phone_number][category] = 0;
            }
            grouped[result.phone_number][category] += (result[category] ?? 0);
          });
        }
      });
      let rows = [];
      Object.keys(grouped).forEach((key) =>{
        rows.push(grouped[key]); 
      });
      return rows;
    },
    categoryLabels(){
      return {
        "marketing_total": this.$t('WHATSAPP_CONSUMPTIONS_REPORT.CATEGORY.TEMPLATES_MARKETING'), 
        "utility_total": this.$t('WHATSAPP_CONSUMPTIONS_REPORT.CATEGORY.TEMPLATES_UTILITY'),        
        "authentication_total": this.$t('WHATSAPP_CONSUMPTIONS_REPORT.CATEGORY.TEMPLATES_AUTHENTICATION'),        
        "service_total": this.$t('WHATSAPP_CONSUMPTIONS_REPORT.CATEGORY.CONVERSATONS_SERVICE'),
        "messages_service_total": this.$t('WHATSAPP_CONSUMPTIONS_REPORT.CATEGORY.MESSAGES_SERVICE'), 
      }
    }
  },
  watch: {
    data(){
      this.currentPage = 1;
    }
  },
  methods: {
    goToPage(page) {
      if (page >= 1 && page <= this.totalPages) {
        this.currentPage = page;
      }
    },
    getTotal(item){
      let total = 0;
      Object.keys(this.categoryLabels).forEach(category => {
        total += item[category];
      });
      return total;
    },
    categoryLabel(category) {
      return this.categoryLabels[category] || "";
    },
  },
};
</script>

<style scoped>
.table-wrapper {
  width: 100%;
  overflow-x: auto;
  max-height: 600px;
  overflow-y: auto;
  border: 1px solid #ddd;
}

table {
  width: 100%;
  border-collapse: collapse;
  min-width: 800px;
}

thead {
  background-color: #2563eb;
  color: white;
}

th,
td {
  padding: 12px;
  text-align: left;
  border-bottom: 1px solid #eaeaea;
  word-break: break-word;
  vertical-align: top;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 200px;
}

.striped-row {
  background-color: #f9f9f9;
}

.pagination {
  margin-top: 20px;
  display: flex;
  justify-content: center;
  gap: 16px;
  align-items: center;
}

.pagination button {
  background-color: #2563eb;
  color: white;
  border: none;
  padding: 8px 14px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
}

.pagination button:disabled {
  background-color: #ccc;
  cursor: not-allowed;
}

.visually-hidden {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}
</style>
